//get domain from hostname. If subdomain is "enroll", the program comes from the domain (tdcomplete, avb-complete),
//else it comes from the subdomain (yardcard, toroxmark)
function getDomainAlias() {
  let programDomain = window.location.hostname.split('.')[0].split('-')[0]
  if (programDomain == 'enroll') {
    programDomain = window.location.hostname.split('.')[1]
  }
  return programDomain
}

export default getDomainAlias



// WEBPACK FOOTER //
// ./src/assets/js/domain.js